import { render, staticRenderFns } from "./MFASection.vue?vue&type=template&id=1177286c&scoped=true"
import script from "./MFASection.vue?vue&type=script&lang=js"
export * from "./MFASection.vue?vue&type=script&lang=js"
import style0 from "./MFASection.vue?vue&type=style&index=0&id=1177286c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1177286c",
  null
  
)

export default component.exports